import React from 'react';
import { Reveal } from './Reveal';
import { withItems, withoutItems } from '../data/offer';
type PanelProps = {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
};
function Panel({
  title,
  label,
  items,
  positive
}: PanelProps) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-31" data-mp="1l5ku9otcira7">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-600'}`} data-id="element-32" data-mp="1pzp1882m2zba">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-33" data-mp="1zwa70vmggeg6">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-34" data-mp="1zy4v2it0wmoh">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-35" data-mp="23you5rx5q0d9">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-36" data-mp="9lyxj2femd26">
      <div className="mx-auto max-w-6xl" data-id="element-37" data-mp="ek0d3ddmfu8w">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-38" data-mp="el1tlxdep8y0">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-39" data-mp="1m1imdlz4kn1w">
            ⚖️ La differenza che un <span className="text-sage" data-id="element-40" data-mp="1h8xu4ovvai0h">vero sistema</span> fa
          </h2>
          <p className="mt-5 text-slate" data-id="element-41" data-mp="1d7vsy2ie3vvv">
            Non stai acquistando file. Stai acquistando un sistema completo di guarigione operazionale.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-42" data-mp="187hmgowfstzy">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-43" data-mp="24zux3c5oq4zl">
            <Panel label="❌ Senza il sistema" title="Senza il Sistema delle Costellazioni Familiari™" items={withoutItems} data-id="element-44" data-mp="20zazk7h78zcx" />
            <Panel positive label="✅ Con il sistema" title="Con il Sistema delle Costellazioni Familiari™" items={withItems} data-id="element-45" data-mp="1r0lfq95qt4u1" />
          </div>
        </Reveal>
      </div>
    </section>;
}